var React = require('react');

function LeftArrowPoint (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"462.745,0 96.212,279.479 462.745,558.957 462.745,419.221 278.713,279.479 462.745,139.738 \t\t"})));
}

LeftArrowPoint.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"558.957px","height":"558.957px","viewBox":"0 0 558.957 558.957","style":{"enableBackground":"new 0 0 558.957 558.957"},"xmlSpace":"preserve"};

module.exports = LeftArrowPoint;

LeftArrowPoint.default = LeftArrowPoint;
